import { render, staticRenderFns } from "./WorkshopTestmodeConfirmModal.vue?vue&type=template&id=5a45cec8"
var script = {}


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports